import get from "lodash/get";
import * as React from "react";
import { connect } from "react-redux";

import {
  MyRewards as MyRewardsComponent,
  MyRewardsProps,
} from "../../components/MyRewards/MyRewards";
import { getCouponsAction, getRewardsAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCoupons,
  getRewards,
  isGetRewardsLoading,
} from "../../reducers/reward/methods";
import { getWidgetConfig } from "../../reducers/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

import { loyaltyDashboardFilteredRewardsAndCoupons } from "./filterLoyaltyRewards";

interface MyRewardsContainerProps extends MyRewardsProps {
  coupons: ReturnType<typeof getCoupons>;
  getCouponsAction: typeof getCouponsAction;
  getRewardsAction: typeof getRewardsAction;
  rewards: ReturnType<typeof getRewards>;
}

class MyRewards extends React.Component<MyRewardsContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getCouponsAction();
      this.props.getRewardsAction();
    }
  }

  componentDidUpdate(prevProps: MyRewardsContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.props.getCouponsAction();
      this.props.getRewardsAction();
    }
  }

  render() {
    return <MyRewardsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => {
  const config = getWidgetConfig(state);
  const rewardStoreWidgetId = get(config, "settings.rewardStoreWidgetId") as
    | string
    | undefined;
  const rawRewards = getRewards(state.reward);
  const rawCoupons = getCoupons(state.reward);
  const { rewards, coupons } = loyaltyDashboardFilteredRewardsAndCoupons({
    rewardStoreWidgetId,
    rewards: rawRewards ?? undefined,
    coupons: rawCoupons ?? undefined,
  });

  return {
    coupons,
    isLoading: isGetRewardsLoading(state.reward),
    rewards,
  };
};

export default connect(mapStateToProp, {
  getCouponsAction,
  getRewardsAction,
})(MyRewards);
